import { Button } from '@mantine/core';
import { QueryClientProvider } from '@tanstack/react-query';
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import Loader from '@/components/Loader';
import { queryClient } from '@/lib/react-query';

const ErrorFallback = () => (
  <div role="alert">
    <h2>Ooops, something went wrong </h2>
    <Button
      className="mt-4"
      onClick={() => {
        window.location.assign(window.location.origin);
      }}
    >
      Refresh
    </Button>
  </div>
);

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => (
  <React.Suspense fallback={<Loader />}>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </ErrorBoundary>
  </React.Suspense>
);
